import React, { createContext, useEffect, useState, useContext } from 'react';
import axiosClient from '../api/axiosClient';

// 🔹 Création du contexte pour stocker et partager les bannières
const BannersContext = createContext();

export const BannersProvider = ({ children }) => {
    const [navbarBanners, setNavbarBanners] = useState(null);
    const [advertisements, setAdvertisements] = useState(null);
    const [popups, setPopups] = useState(null);

    const fetchBanners = () => {
        axiosClient.get("/dashboard/user/organizer/interfaceManager/Ooth23i")
            .then((response) => {
                // console.log('loga');
                const currentDate = new Date();
                
                const activeBanners = response.data.filter((banner) => {
                    const startDate = new Date(banner.start_date);
                    const endDate = new Date(banner.end_date);
                    return banner.is_active && currentDate >= startDate && currentDate <= endDate;
                });
                // 🔹 Filtrage par type
                setNavbarBanners(activeBanners.find(b => b.type === "navbar_notification") || null);
                setAdvertisements(activeBanners.find(b => b.type === "section_advertisement") || null);
                setPopups(activeBanners.find(b => b.type === "popup") || null);
                
            })
            // .catch((error) => console.error("Erreur récupération bannières :", error));
    };

    useEffect(() => {
        fetchBanners(); // Récupérer les bannières au montage du composant

        const interval = setInterval(() => {
            fetchBanners(); // Rafraîchir les bannières toutes les X secondes
        }, 300000); // 🔹 Rafraîchissement Toutes les 5 minutes (modifiable)

        return () => clearInterval(interval); // Nettoyer l'intervalle lors du démontage
    }, []);

    return (
        <BannersContext.Provider value={{ navbarBanners, advertisements, popups }}>
            {children}
        </BannersContext.Provider>
    );
};

// 🔹 Hook personnalisé pour utiliser les bannières partout
export const useBanners = () => useContext(BannersContext);
